// @flow

import * as React from 'react';
import Box from 'sail/Box';
import CopyAction from './CopyAction';
import Arrow from './Arrow';
import {getSurroundingChars, COLORS} from './helpers';

type Props = {
  rootKey?: string,
  children: React.Node,
  hasTrailingComma?: boolean,
  onClick: () => void,
  isArray?: boolean,
  data: Object,
  canCopy?: boolean,
};

const LineStack = ({
  rootKey,
  children,
  hasTrailingComma,
  onClick,
  isArray = false,
  data,
  canCopy,
}: Props) => {
  const [leading, trailing] = getSurroundingChars(isArray);

  return (
    <pre className="LineStack" style={{color: COLORS.default}}>
      <Box className="CollapsibleKey" onClick={onClick}>
        {canCopy && <CopyAction data={data} className="CopyAction--left" />}
        <Arrow style={{left: '-16px'}} />
        <span>
          {!!rootKey && (
            <>
              <span style={{color: COLORS.string}}>{`"${rootKey}"`}</span>
              {': '}
            </>
          )}
          {leading}
        </span>
      </Box>
      <Box margin={{left: 16}}>{children}</Box>
      <span>{`${trailing}${hasTrailingComma ? ',' : ''}`}</span>
    </pre>
  );
};

export default LineStack;
